import React, {useEffect, useState} from 'react';
import {Frame} from "types/Frame";
import ConfirmModal from "components/ConfirmModal";
import {invalidate} from "services/query-client";
import {useMutation} from "react-query";
import ngage from "services/ngage";

type Props = {
    frame: Frame | null
    show: boolean
    onDelete?: (frame: Frame) => any
    onDeleteFail?: (frame: Frame, error: unknown) => any
    onCancel?: () => any
}

function DeleteFrame(props: Props) {
    const {frame, show, onDelete, onDeleteFail, onCancel} = props

    const [name, setName] = useState<string>(frame?.name || 'this frame');
    const {mutateAsync: deleteFrame} = useMutation(ngage.frames.destroy)

    useEffect(() => {
        if(frame) setName(frame.name)
    }, [frame]);

    async function handleDeleteFrame() {
        if (frame) {
            try {
                await deleteFrame(frame.id)
                await invalidate('frames.all')

                if (onDelete) onDelete(frame)
            } catch (error) {
                if (onDeleteFail) onDeleteFail(frame, error)
            }
        }
    }

    function handleCancel() {
        if (onCancel) onCancel()
    }

    return (
        <ConfirmModal
            show={show}
            type={ConfirmModal.types.DANGER}
            title="Delete Frame"
            body={`Are you sure you want to permanently delete '${name}'? This action cannot be undone.`}
            approveLabel="Delete"
            onApprove={handleDeleteFrame}
            onCancel={handleCancel}
        />
    );
}

export default DeleteFrame;